<div class="hidewhenloading" #hidewhenloading>
  <div class="d-flex flex-column flex-lg-row gap-1.5">
    <div #lessonNoteWrap class="d-flex flex-column flex-fill"
      [style]="'height: calc(100vh - ' + lessonNoteWrap.offsetTop + 'px - var(--main-padding)); min-height: 500px;'">
      <div class="d-flex mb-1 justify-content-between align-items-center">
        <h3 class="align-middle w-75" *ngIf="lessonnote[0]?.id != 0"> {{lessonnote[currentPage - 1]?.title.length > 0 ? lessonnote[currentPage - 1]?.title : "Section " + currentPage}} </h3>
        <app-text-reader class="mw-25" *ngIf="textReaderReady" [htmltext]="textToRead" [textarea]="textarea" [hasMedia]="hasMedia"></app-text-reader>
      </div>      
      <div appExternallinksdirective class="card shadow-sm-darker flex-fill overflow-auto">
        <div #lessonnotearea class="card-body innerHTML-wrap" *ngIf="lesson.note && lesson.note.safeContent !='' && !hasemptytag"
          [innerHTML]="notehtml">
        </div>    
        <div class="card-body" *ngIf="!lesson.lecture && (!lesson.note || lesson.note.safeContent=='' || hasemptytag)">
          <button *ngIf="this.lesson.adminuser" routerLink="/user/lessonnote"
            [queryParams]="{ moduleID: this.moduleid, classid: this.classid }" class="btn">
            <i class="fas fa-edit"></i> Create Note / Media For Lesson
          </button>
        </div>
      </div>
      <div class="d-flex justify-content-center">  
        <button class="btn m-0 note-page" (click)="previousPage()" type="submit" [disabled]="currentPage == 1 && !prevlesson">
          <span><i class="fa fa-angle-left"></i> {{currentPage == 1 && prevlesson ? 'Previous Lesson' : 'Previous'}}</span>
       </button>
     
       <button class="btn m-0 note-page" (click)="nextPage()" type="submit" [disabled]="!enableNextLesson && currentPage == this.lessonnote.length">
         <span>{{lessonnote.length == currentPage && enableNextLesson ? 'Next Lesson' : 'Next'}} <i class="fa fa-angle-right"></i></span> 
       </button>
      </div>
      
      <button *ngIf="!this.lesson.adminuser && this.currentPage == this.lessonnote.length && !showInclassAssessement" class="completion-button" 
            [ngClass]="[isClassCompleted?'btn btn--sm m-0' :'btn btn--sm m-0 bg-warning', enableNextLesson ? 'mr-3' : '']"
            (click)="markCompletedclicked()" title="Mark as Complete">{{isClassCompleted ? 'Completed' : 'Mark Completed'}}
            <i *ngIf="isClassCompleted" class="fa fa-check-square ml-2"></i>
            <i *ngIf="!isClassCompleted" class="fa fa-square ml-2"></i>
          </button>
          
      <div class="card shadow-sm-darker p-2 mt-4" *ngIf="showInclassAssessement">
        <h2 class="text-center">Quiz</h2>
        <ul class="list-unstyled m-0" #questionPane>
          <li *ngFor="let question of this.questions; let optionGroupIndex = index">
            <div class="std-qst">
              <h4 class="text-xs mb-3"><span class="text-primary-darker">QUESTION {{optionGroupIndex + 1}}</span>
                of {{this.assessment.questions.length}} 
              </h4>
              <div class="inlineOptions innerHTML-wrap" [innerHTML]="question.text | customhtmlsanitizer">
              </div>
             
            </div>
          </li>
        </ul>
        <div class="card-footer text-center p-0" #buttonPane>
          <div class="mt-3" *ngIf="isScored">
            <p *ngIf="failedMessage" class="text-warning">{{failedMessage}}</p>
            <!-- <h4 class="font-weight-500 text-uppercase">Total Score:</h4><span class="text-sm">{{score}}</span> -->
          </div>
          <div *ngIf="questionCount > 1" class="d-flex flex-wrap gap-1.5 mb-4 mt-2"
            [ngClass]="{'justify-content-start': hideQuestionNavButton !== 2 && questionCount > 1, 'justify-content-between': hideQuestionNavButton !== 2 && questionCount > 1 && hideQuestionNavButton !== 1, 'justify-content-end': hideQuestionNavButton !== 1 }">
            <button type="button" class="btn btn--sm m-0" *ngIf="hideQuestionNavButton !== 2 && questionCount > 1"
              (click)="getQuestionToShow(questionInView.previous)"><i
                class="fa fa-angle-left"></i><span>Previous</span></button>
            <button type="button" class="btn btn--sm m-0" *ngIf="hideQuestionNavButton !== 1"
              (click)="getQuestionToShow(questionInView.next)"><span>Next</span><i class="fa fa-angle-right"></i></button>
          </div>
          <div class="mb-4" *ngIf="this.questions && this.questions.length > 1">
            <button type="button" class="badge badge-lg border-0 m-2 questionBadge" (click)="getQuestionToShow(badgeIndex)"
              *ngFor="let question of this.questions; let badgeIndex = index"  [ngClass]="{'red-color': question.isValid === 0}">{{badgeIndex + 1}}</button>
          </div>
          <div class="d-flex justify-content-center flex-wrap gap-1.5">
            <button type="submit" class="btn m-0" id="submit" [disabled]="submitinProgress" (click)="saveAssessment()"
              *ngIf="assessment && showsubmit && !showRetake && !this.lesson.adminuser">Submit</button>
          </div>
          <div class="d-flex justify-content-center flex-wrap gap-1.5">
            <button type="submit" class="btn m-0" id="submit" [disabled]="submitinProgress" (click)="retakeAssessment()"
              *ngIf="showRetake && !this.lesson.adminuser">Retake</button>
          </div>
        </div>
      </div>
      
    </div>
    <aside class="course-extras-aside flex-shrink-0">
      <!-- <section id="lessonliveschedule" class="card shadow-sm-darker">
        <h3 class="card-header">Live Lesson Schedule</h3>
        <div class="card-body text-sm">
          <button *ngIf="lesson.adminuser" class="btn btn--sm m-auto" routerLink="/user/schedulelivelesson"
            [queryParams]="{ classid: this.classid }">
            <i class="fa fa-calendar"></i> Schedule Live Lesson
          </button>
          <p *ngIf="(!liveclassschedules || liveclassschedules.length==0) && !lesson.adminuser"
            class="text-inherit font-italic mb-0">There Are No Live Classes Scheduled</p>
          <div class="classmaterial" *ngFor="let liveclassschedule of liveclassschedules">
            <app-liveclass [liveclassschedule]=liveclassschedule [adminuser]="lesson.adminuser"
              (deleteSchedule)="deleteliveclassschedule($event)"></app-liveclass>
          </div>
        </div>
      </section> -->
      <section id="upcomingEvent" class="card shadow-sm-darker">
        <h3 class="card-header">Upcoming/Ongoing Events</h3>
        <div class="card-body text-sm pt-1">
          <table class="table" *ngIf="displayEvents.length > 0">
            <thead>
              <tr>
                <th> Status </th>
                <th> Start Date</th>
                <th> End Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of displayEvents">
                <td class="td-pt">{{getStatus(item)}}</td>
                <td class="td-pt">{{this.util.formatDate(item.inviteStartDate)}}</td>
                <td class="td-pt">{{this.util.formatDate(item.inviteEndDate)}}</td>
                <td *ngIf="canJoinEvents(item)"><button class="btn btn--sm m-auto p-1" (click)="joinEvent(item.venue)">Join</button></td>
              </tr>
            </tbody>
          </table>
          <p class="text-inherit font-italic mb-0">{{this.schoolModuleEvent.length > 0 ? this.schoolModuleEvent.length === 1 ?
            this.schoolModuleEvent.length + ' Event':
            this.schoolModuleEvent.length + ' Events': 'There Are No Events'}} Available</p>
          <button *ngIf="this.schoolModuleEvent.length > 0" class="btn btn--sm m-auto"
            (click)="gotoUpcomingEvents()">
            <i class="fas fa-eye"></i> View All Events
          </button>
        </div>
      </section>
      <section id="lessonmaterials" class="card shadow-sm-darker">
        <h3 class="card-header">Lesson Materials</h3>
        <div class="card-body text-sm">
          <p *ngIf="(!classfiles || classfiles.length==0) && !lesson.adminuser" class="text-inherit font-italic mb-0">
            There Are No Lesson Materials</p>
          <button *ngIf="lesson.adminuser && !showlessonfileupload" class="btn btn--sm m-auto"
            (click)="togglelessonfileupload(1)">
            <i class="fas fa-file"></i> Add file
          </button>
          <form *ngIf="showlessonfileupload" (ngSubmit)="saveclassfile(files.files)">
            <p class="text-center text-sm">{{classFileName || 'No File Selected'}}</p>
            <button (click)="files.click()" type="button" id="filesLabel" class="btn btn--sm m-auto">Select
              File</button>
            <input #files (change)="classFileName = files.files[0]?.name" type="file" name="files"
              aria-labelledby="filesLabel" id="classfile" class="sr-only" required>
            <div class="d-flex justify-content-around flex-wrap gap-.3 mt-4">
              <button type="submit" class="btn btn--sm m-0" [disabled]="files.files.length < 1">Upload</button>
              <button type="button" class="btn btn--warning btn--sm m-0"
                (click)="showlessonfileupload = false; classFileName = ''">Cancel</button>
            </div>
          </form>
          <div *ngIf="classfiles" class="mt-4">
            <div class="classmaterial mt-2" *ngFor="let file of classfiles">
              <app-classmaterial [file]=file [adminuser]="lesson.adminuser" (deletefile)="deleteclassfile($event)">
              </app-classmaterial>
            </div>
          </div>
        </div>
      </section>
      <section id="lessonassessments" class="card shadow-sm-darker mb-0">
        <h3 class="card-header">Assessments</h3>
        <div class="card-body text-sm">
          <p class="text-inherit font-italic mb-0">{{this.lesson.assessments > 0 ? this.lesson.assessments === 1 ?
            this.lesson.assessments + ' Assessment':
            this.lesson.assessments + ' Assessments': 'There Are No Assessments'}} Available</p>
          <p *ngIf="this.lesson.assessments > 0 || this.lesson.adminuser" class="text-xs text-center mt-3 mb-0"><a routerLink="/user/assessmentconsole"
              [queryParams]="{ classid: this.classid, batchid:  this.batchid }" class="text-link">{{ this.lesson.adminuser ? 'Manage Assessments' : 'View Assessments'}}</a></p>
        </div>
      </section>
    </aside>
  </div>
</div>

<div class="modal fade" id="deleteLesson" data-keyboard="false" data-backdrop="static" aria-hidden="true" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Delete Lesson</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <p class="text-center pb-2">Are you sure you want to delete this lesson?</p>
        <div class="d-flex justify-content-center flex-wrap gap-1.5">
          <button type="submit" class="btn btn--danger m-0" (click)="deleteLesson()">Delete</button>
          <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="deleteLessonnote" data-keyboard="false" data-backdrop="static" aria-hidden="true"
  role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Delete Note</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <p class="text-center pb-2">Every page will be removed permanently!</p>
        <p class="text-center pb-2">Are you sure you want to delete this note?</p>
        <div class="d-flex justify-content-center flex-wrap gap-1.5">
          <button type="submit" class="btn btn--danger m-0" (click)="deleteLessonnote()">Delete</button>
          <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
